import { get } from 'lodash';
import { Reducer } from 'redux';
import { IAction } from '@shared/types';
import { IUiState } from './ui/ui.reducer';
import { XVIError } from '@shared/models';

export interface IBaseState {
  currentDocument: any;
  entityId: string;
  items: any[];
  itemCaptions: {
    [key: string]: string;
  };
  errors: XVIError;
  total: number;
  filter?: string;
  orderby?: string;
  schema: any;
  isSchemaRequested?: boolean;
  previousRequest: object;
  operationResult: any;
  current_page?: number;
  page_count?: number;
  page_size?: number;
  dataRequested?: boolean;
}

export type SubReducerFunc = (
  state: any,
  propertyName: string,
  reducer: Reducer<any>,
  action: IAction,
) => any;

export const INITIAL_STATE: IBaseState = {
  currentDocument: null,
  entityId: null,
  items: [],
  itemCaptions: {},
  errors: null,
  total: null,
  filter: null,
  orderby: null,
  schema: null,
  previousRequest: null,
  operationResult: null,
  current_page: 1,
  page_count: 1,
  page_size: 0,
};

export const applySubReducer: SubReducerFunc = (
  state: any,
  propertyName: string,
  reducer: Reducer<any>,
  action: IAction,
): IUiState => {
  const subState: object = get(state, propertyName);
  const newSubstate: object = reducer(subState, action);
  const hasChanges: boolean = subState !== newSubstate;

  return hasChanges
    ? Object.assign({}, state, { [propertyName]: newSubstate })
    : state;
};
